import { entityTypeApi } from "../api";

const EntityTypeService = {
  fetchDropdown: async () => {
    const response = await entityTypeApi.fetchCustom('/dropdown');
    return response.data;
  },
};

export default EntityTypeService;
